import { render } from "./Servicess.vue?vue&type=template&id=436b2d76&scoped=true"
import script from "./Servicess.vue?vue&type=script&lang=js"
export * from "./Servicess.vue?vue&type=script&lang=js"

import "./Servicess.vue?vue&type=style&index=0&id=436b2d76&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-436b2d76"

export default script